import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';

const usePartnerLoginDialogue = (response?: {
  Success: boolean;
  ErrorMessage?: string;
}): { showDialogue: () => void } => {
  const errorMessage: string = response?.ErrorMessage || '';

  const history = useHistory();
  const { provideProps, showDialogue } = useConfirmationDialogue();

  const messageMap: { [key: string]: string } = {
    'Invalid Username/Password combination': 'The current password that has been provided is not correct.',
  };

  useEffect(() => {
    const handlers = {
      success: () => {
        provideProps({
          title: 'Success! Your password has been updated.',
          subTitle: 'The next time you sign in you will be required to use your new password.',
          status: 'success',
          confirm: {
            label: 'Back to Dashboard',
            action: () => {
              history.push('/dashboard');
            },
          },
          cancel: {
            label: 'Stay here.',
            action: () => {},
          },
        });
      },
      errorMessage: () => {
        provideProps({
          title: 'Error! There has been a problem with the provided passwords.',
          subTitle: messageMap[errorMessage] || errorMessage,
          status: 'error',
          confirm: {
            label: 'Back to Dashboard',
            action: () => {
              history.push('/dashboard');
            },
          },
          cancel: {
            label: 'Stay here and try again',
            action: () => {},
          },
        });
      },
    };

    if (errorMessage) return handlers.errorMessage();

    return handlers.success();
  }, [errorMessage]);

  return { showDialogue };
};

export default usePartnerLoginDialogue;
